import React from "react";
import { Dropdown } from "antd";
import MoreIcon from "@material-ui/icons/MoreVertOutlined";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "../../../assets/card_icons/ShareIcon";
import BookmarkIcon from "../../../assets/card_icons/BookmarkIcon";
import BookmarkFilledIcon from "../../../assets/card_icons/BookmarkFIlledIcon";
import DeleteIcon from "../../../assets/card_icons/DeleteIcon";
import { useHistory } from "react-router-dom";
import ConfirmModal from "../../mega/ConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import { deletePost } from "../../../redux/actions/postAction";
import { useAuthStore } from "../../../store/AuthStore";

const ArticleIcons = ({
  post,
  handleBookmark,
  handleShare,
  handleFlagging,
  isBookmarkTab,
  isMyPostTab,
  removeBookmark,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { blogData, setAuthData, userData } = useAuthStore();

  const normalPosts = [
    { label: "View", key: "view" },
    { label: "Edit", key: "edit" },
    // { label: "Flag", key: "flag_blogpost", danger: true },
  ];

  const deletePosts = [
    {
      label: (
        <ConfirmModal
          title="Are you sure you want to delete?"
          btnName="Delete"
          onOk={() => {
            dispatch(deletePost(post.id));
            setAuthData({
              blogData: {
                ...blogData,
                postCount: blogData.postCount - 1,
              },
            });
          }}
        />
      ),
      key: "delete",
      danger: true,
    },
  ];

  const handleActions = ({ key }) => {
    if (key === "edit") {
      history.push({
        pathname: `/createPost/${post.blogId}/post/${post.id}`,
        state: { isEdit: true },
      });
    } else if (key === "view") {
      history.push(`/viewpost/${post.urlSlug}`);
    } else if (key === "flag_blogpost") {
      handleFlagging();
    }
  };

  const menuProps = {
    onClick: handleActions,
    items:
      post.status === "active" ? [...normalPosts, ...deletePosts] : deletePosts,
  };

  return (
    <div className="icons">
      {!isBookmarkTab && post.status === "active" && (
        <IconButton onClick={handleBookmark}>
          {post.isBookmarked ? <BookmarkFilledIcon /> : <BookmarkIcon />}
        </IconButton>
      )}

      {post.status === "active" && (
        <IconButton onClick={handleShare}>
          <ShareIcon />
        </IconButton>
      )}

      {isBookmarkTab && (
        <IconButton onClick={removeBookmark}>
          <DeleteIcon />
        </IconButton>
      )}

      {isMyPostTab && post?.blog?.author?.id === userData.id && (
        <Dropdown menu={menuProps} trigger={["click"]}>
          <IconButton onClick={(e) => e.stopPropagation()}>
            <MoreIcon style={{ color: "#000" }} />
          </IconButton>
        </Dropdown>
      )}
    </div>
  );
};

export default ArticleIcons;
